import { BlocksIconTools } from 'blocks-nextjs/blocks-web-components/components/icon/icons/tools';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconTools = createComponent({ react: React, tagName: 'cat-icon-tools', elementClass: BlocksIconTools });
